export default function MediaHeader() {
  return (
    <section className="relative w-full min-h-[50vh] md:min-h-[55vh] overflow-hidden bg-brand-gradient flex items-end">
      <div className="relative z-10 w-full px-6 md:px-10 lg:px-16 pb-14 md:pb-20">
        <div className="max-w-3xl mx-auto text-center opacity-0 animate-[heroTextReveal_1s_cubic-bezier(0.25,0.1,0.25,1)_0.1s_forwards]">
          <div className="flex items-center justify-center gap-3 mb-5">
            <span className="w-8 h-[1px] bg-foreground-50/40" />
            <span className="text-foreground-50/70 text-xs tracking-[0.2em] uppercase font-medium">
              Watch &amp; Listen
            </span>
            <span className="w-8 h-[1px] bg-foreground-50/40" />
          </div>
          <h1 className="font-heading text-5xl md:text-8xl lg:text-9xl text-foreground-50 leading-none tracking-[0.03em]">
            Media
          </h1>
        </div>
      </div>
    </section>
  );
}